(function(){
  document.addEventListener('DOMContentLoaded', function(){
    try {
      // Read config either from a JSON script or from #timer-config data attributes
      var cfg = null;
      var cfgScript = document.querySelector('script[data-timer-config]');
      if(cfgScript){
        try{ cfg = JSON.parse(cfgScript.textContent || cfgScript.innerText || '{}'); }catch(e){ cfg = null; }
      }
      var cfgDiv = document.getElementById('timer-config');
      if(!cfg){
        if(cfgDiv){
          cfg = {
            enabled: cfgDiv.dataset.enabled === 'true' || cfgDiv.dataset.enabled === true,
            startTime: Number(cfgDiv.dataset.startTime) || 0,
            stepMajor: Number(cfgDiv.dataset.stepMajor) || Number(cfgDiv.dataset.stepMajor) || 0,
            isDecrease: (cfgDiv.dataset.isDecrease === 'true' || cfgDiv.dataset.isDecrease === true),
            checkIntervalMinutes: Number(cfgDiv.dataset.checkIntervalMinutes) || Number(cfgDiv.dataset.checkIntervalMinutes) || 1
          };
        }
      }
      if(!cfg || !cfg.enabled) return console.info('Price timer (product): no config');

      const startTime = Number(cfg.startTime) || 0;
      const stepMajor = Number(cfg.stepMajor) || 0;
      const isDecrease = Boolean(cfg.isDecrease);
      const checkIntervalMinutes = Number(cfg.checkIntervalMinutes) || 1;

      // New: read product-level max intervals so we can stop product banner when reached
      const productMaxNode = document.getElementById('product-max-intervals');
      const productMaxIntervals = (function(){
        // Try to get max intervals from template first
        if (productMaxNode) {
          var v = productMaxNode.dataset && productMaxNode.dataset.maxIntervals ? productMaxNode.dataset.maxIntervals : productMaxNode.getAttribute('data-max-intervals');
          var templateMax = parseInt(v,10);
          if (!isNaN(templateMax) && templateMax > 0) {
            console.log('Using template max intervals:', templateMax);
            return templateMax;
          }
        }
        
        // Calculate max intervals based on actual HTML prices
        try {
          const priceEl = document.querySelector('[data-timer-adjustable-price]');
          if (!priceEl) {
            console.log('No price element found for max intervals calculation');
            return NaN;
          }
          
          const currentPrice = parseCentsFromDisplay(priceEl.textContent);
          const targetAttr = priceEl.getAttribute('data-original-price');
          const targetPrice = targetAttr ? (/^\d+$/.test(targetAttr.trim()) ? parseInt(targetAttr.trim(), 10) : parseCentsFromDisplay(targetAttr)) : null;
          
          if (currentPrice != null && targetPrice != null) {
            const priceDiff = Math.abs(targetPrice - currentPrice);
            const stepCents = centsFromMajor(stepMajor);
            
            // Add buffer of 2-3 extra intervals to ensure we don't stop too early
            const baseCalculation = Math.floor(priceDiff / stepCents);
            const calculatedMax = baseCalculation + 3; // Safety buffer
            
            console.log('Calculated max intervals from actual prices:', {
              currentPrice: currentPrice,
              targetPrice: targetPrice,
              priceDiff: priceDiff,
              stepCents: stepCents,
              baseCalculation: baseCalculation,
              calculatedMax: calculatedMax,
              note: 'Added 3 intervals buffer for safety'
            });
            
            return calculatedMax > 0 ? calculatedMax : NaN;
          }
        } catch (e) {
          console.error('Error calculating max intervals:', e);
        }
        
        console.log('Could not determine max intervals');
        return NaN;
      })();

      function hasReachedTargetPrice() {
        try {
          // Get the current displayed price
          const priceEl = document.querySelector('[data-timer-adjustable-price]');
          if (!priceEl) return false;
          
          const currentPrice = parseCentsFromDisplay(priceEl.textContent);
          if (currentPrice == null) return false;
          
          // Get the target price from data attribute
          const targetAttr = priceEl.getAttribute('data-original-price');
          if (!targetAttr) return false;
          
          const targetPrice = /^\d+$/.test(targetAttr.trim()) ? 
            parseInt(targetAttr.trim(), 10) : 
            parseCentsFromDisplay(targetAttr);
          
          if (targetPrice == null) return false;
          
          // Debug: log the actual prices JavaScript sees
          console.log('Price check:', {
            currentPrice: currentPrice,
            targetPrice: targetPrice,
            currentDisplay: priceEl.textContent,
            targetAttr: targetAttr,
            isDecrease: isDecrease
          });
          
          // CORRECTED LOGIC: 
          // For INCREASE timers: start low, go up to target - stop when we reach or exceed target
          // For DECREASE timers: start high, go down to target - stop when we reach or go below target
          if (isDecrease) {
            // Stop when current price reaches or goes below the target price
            const hasReached = currentPrice <= targetPrice;
            console.log(`Decrease timer: currentPrice (${currentPrice}) <= targetPrice (${targetPrice}) = ${hasReached}`);
            return hasReached;
          } else {
            // Stop when current price reaches or exceeds the target price
            const hasReached = currentPrice >= targetPrice;
            console.log(`Increase timer: currentPrice (${currentPrice}) >= targetPrice (${targetPrice}) = ${hasReached}`);
            return hasReached;
          }
        } catch (e) {
          console.error('hasReachedTargetPrice error:', e);
          return false;
        }
      }

      function shouldStopTimer(steps) {
        // Only use target price check - max intervals calculation from template is unreliable
        const maxIntervalsReached = false; // Disabled: template calculation is often wrong
        
        const targetPriceReached = hasReachedTargetPrice();
        
        console.log('shouldStopTimer debug:', {
          steps: steps,
          productMaxIntervals: productMaxIntervals,
          maxIntervalsReached: maxIntervalsReached,
          targetPriceReached: targetPriceReached,
          willStop: maxIntervalsReached || targetPriceReached,
          note: 'Only using target price check - max intervals disabled'
        });
        
        return maxIntervalsReached || targetPriceReached;
      }
 
      function stopProductTimerAndShowEnded() {
        try {
          timerEnded = true;
          
          const banner = document.getElementById('product-price-timer');
          const progress = document.getElementById('price-timer-progress');
          const countdown = document.getElementById('timer-countdown');
          const endedMsg = document.getElementById('timer-ended-message');
          const changeEl = document.getElementById('timer-upcoming-change');
          if (progress) try { progress.style.width = '100%'; } catch(e){}
          if (countdown) try { countdown.textContent = '--:--:--'; } catch(e){}
          if (banner) try { banner.style.backgroundColor = '#E11D48'; banner.classList.add('price-timer-ended'); banner.setAttribute('data-timer-ended', 'true'); } catch(e){}
          if (endedMsg) try { endedMsg.style.display = 'block'; endedMsg.textContent = 'Bedre held næste gang.'; } catch(e){}
          if (changeEl) try { changeEl.textContent = (isDecrease ? '-' : '+') + '0 ' + getCurrencySymbol(); } catch(e){}

          // mark ended globally and stop background checks
          try { window.__priceTimerEnded = true; } catch(e){}
          try { if (typeof mainIntervalId !== 'undefined' && mainIntervalId) { clearInterval(mainIntervalId); mainIntervalId = null; } } catch(e){}
          try { if (typeof safetyIntervalId !== 'undefined' && safetyIntervalId) { clearInterval(safetyIntervalId); safetyIntervalId = null; } } catch(e){}
          try { if (typeof __priceTimerNextTimeout !== 'undefined' && __priceTimerNextTimeout) { clearTimeout(__priceTimerNextTimeout); __priceTimerNextTimeout = null; } } catch(e){}
        } catch (e) { /* ignore */ }
      }

      // Disable #addToCartButton until initial price synchronization has completed
      function disableAddToCart(){
        try{
          var btn = document.querySelector('#addToCartButton');
          if(btn){
            btn.setAttribute('disabled','disabled');
            btn.dataset._origCursor = btn.style.cursor || '';
            btn.style.cursor = 'not-allowed';
            btn.setAttribute('aria-disabled','true');
          }
        }catch(e){/* silent */}
      }
      function enableAddToCart(){
        try{
          var btn = document.querySelector('#addToCartButton');
          if(btn){
            btn.removeAttribute('disabled');
            btn.style.cursor = btn.dataset._origCursor || '';
            try{ delete btn.dataset._origCursor; }catch(e){}
            btn.removeAttribute('aria-disabled');
          }
        }catch(e){/* silent */}
      }

      // prevent adding to cart until we've done the initial price update
      disableAddToCart();

      // internal state
      let timerEnded = false;

      function centsFromMajor(m){ return Math.round(m * 100); }
      function getCurrencySymbol() {
        // Try to get currency symbol from Shopify's currency object
        if (typeof window.Shopify !== 'undefined' && window.Shopify.currency && window.Shopify.currency.active) {
          const currencyCode = window.Shopify.currency.active;
          // Map common currency codes to symbols
          const currencySymbols = {
            'USD': '$', 'EUR': '€', 'GBP': '£', 'DKK': 'kr', 'SEK': 'kr', 'NOK': 'kr',
            'JPY': '¥', 'CAD': '$', 'AUD': '$', 'CHF': 'CHF', 'PLN': 'zł', 'CZK': 'Kč'
          };
          return currencySymbols[currencyCode] || currencyCode;
        }
        return 'kr'; // fallback
      }
      function formatPriceFromCents(cents){ 
  const major = (cents/100).toFixed(2); 
  const currencySymbol = getCurrencySymbol();
  // Always format as "300,00 kr" (amount + space + symbol)
  var _p = major.split('.'); return _p[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + _p[1] + ' ' + currencySymbol;
      }
      function formatBspFromCents(cents){ var c = Number(cents); if(isNaN(c)) return ''; var major = Math.floor(c/100); var centsPart = Math.abs(c%100); var centsStr = centsPart<10 ? '0'+centsPart : String(centsPart); return '['+major+'.'+centsStr+']'; }
      function parseCentsFromDisplay(display){ 
        if(!display) return null; 
        const currencySymbol = getCurrencySymbol();
        var cleaned = String(display).replace(new RegExp(currencySymbol, 'g'),'').trim(); 
        cleaned = cleaned.replace(/[^0-9.,]/g,'');  
        if(cleaned.indexOf('.')!==-1 && cleaned.indexOf(',')!==-1){ 
          cleaned = cleaned.replace(/\./g,'').replace(/,/,'.'); 
        } else { 
          cleaned = cleaned.replace(/,/,'.'); 
        } 
        var num = parseFloat(cleaned); 
        if(isNaN(num)) return null; 
        return Math.round(num*100); 
      }

      function updateFormBspInForm(form, newCents){ if(!form) return; form.querySelectorAll('input[name="properties[_bsp]"]').forEach(input => { input.value = formatBspFromCents(newCents); }); }

      // Debug
      try { console.info('price-timer-product init', {startTime: startTime, stepMajor: stepMajor, isDecrease: isDecrease, checkIntervalMinutes: checkIntervalMinutes}); } catch(e){}

      // Check if timer should already be stopped on load
      const initialSteps = getElapsedSteps();
      if (shouldStopTimer(initialSteps)) {
        console.log('Timer already ended on load - stopping immediately');
        stopProductTimerAndShowEnded();
        return;
      }

      function normalizeBspInputs(){
        var inputs = document.querySelectorAll('input[name="properties[_bsp]"]');
        inputs.forEach(function(input){
          try{
            var v = (input.value||'').trim();
            if(!v) return;
            if(v[0] === '[' && v[v.length-1] === ']'){
              var inner = v.slice(1,-1).trim();
              if(inner === '') return;
              var parts = inner.split(',').map(function(p){ return p.trim(); }).filter(Boolean);
              var out = parts.map(function(item){
                if(/^\d+$/.test(item)){
                  var cents = parseInt(item,10);
                  var major = Math.floor(cents/100);
                  var centsPart = Math.abs(cents%100);
                  var centsStr = centsPart < 10 ? ('0'+centsPart) : String(centsPart);
                  return major + '.' + centsStr;
                }
                if(/^\d+\.\d{2}$/.test(item)) return item;
                var p = parseCentsFromDisplay(item);
                if(p != null){
                  var maj = Math.floor(p/100);
                  var cp = Math.abs(p%100);
                  var cs = cp < 10 ? ('0'+cp) : String(cp);
                  return maj + '.' + cs;
                }
                return item;
              });
              input.value = '[' + out.join(',') + ']';
            }
          }catch(e){
            console.warn('normalizeBspInputs product', e);
          }
        });
      }

      // core
      var lastProcessedSteps = -1;
      function getNowSeconds(){ return Math.floor(Date.now()/1000); }
      function getElapsedSteps(){ const now = getNowSeconds(); if(now<=startTime) return 0; const elapsedSec = now - startTime; const elapsedMin = Math.floor(elapsedSec/60); if(checkIntervalMinutes<=0) return 0; return Math.floor(elapsedMin / checkIntervalMinutes); }

      function updatePricesForSteps(steps){
        console.debug('price-timer-product.updatePricesForSteps', {steps: steps, lastProcessedSteps: lastProcessedSteps});
        const sign = isDecrease ? -1 : 1;
        const stepDelta = centsFromMajor(stepMajor) * sign;
        var foundAny = false;
        document.querySelectorAll('#product-section [data-timer-adjustable-price]').forEach(el => {
          foundAny = true;
          try{
            const appliedAttr = el.getAttribute('data-applied-steps');
            const applied = (appliedAttr!=null && appliedAttr!=='')?parseInt(appliedAttr,10):null;
            const displayedCents = parseCentsFromDisplay(el.getAttribute('data-timer-adjustable-price') || el.textContent);
            if(displayedCents==null) {
              console.warn('price-timer-product: cannot parse displayed price for element', el);
              return;
            }
            const capAttr = el.getAttribute('data-original-price');
            const capCents = (capAttr && String(capAttr).trim()!=='') ? (/^\d+$/.test(String(capAttr).trim())?parseInt(String(capAttr).trim(),10):parseCentsFromDisplay(capAttr)) : null;

            if(applied==null){ el.setAttribute('data-applied-steps', String(steps)); el.setAttribute('data-timer-adjustable-price', formatPriceFromCents(displayedCents)); return; }
            const diff = steps - applied; if(diff===0) return;
            let newCents = displayedCents + (stepDelta * diff);
            if(capCents!=null){ if(!isDecrease){ if(newCents>capCents) newCents = capCents; } else { if(newCents<capCents) newCents = capCents; } }
            el.setAttribute('data-timer-adjustable-price', formatPriceFromCents(newCents)); el.innerText = formatPriceFromCents(newCents); el.setAttribute('data-applied-steps', String(steps));
            console.debug('price-timer-product: updated element', {productId: el.getAttribute('data-product-id'), newCents: newCents});
            const productId = el.getAttribute('data-product-id');
            if(productId){ const form = document.querySelector('#add_to_cart_container form[action*="/cart/add"]'); if(form) updateFormBspInForm(form, newCents); }
            else { const form = el.closest('form'); if(form) updateFormBspInForm(form, newCents); }

          }catch(e){ console.error('price-timer-product update', e); }
        });
        if(!foundAny) console.info('price-timer-product: no adjustable price elements found on page');

        // update inputs
        document.querySelectorAll('input[name="properties[_bsp]"]').forEach(input => {
          try{
            const card = input.closest('.product_card, .product-card, .product'); if(!card) return; const adj = card.querySelector('[data-timer-adjustable-price]'); if(!adj) return; const adjVal = adj.getAttribute('data-timer-adjustable-price'); if(!adjVal) return; const cents = parseCentsFromDisplay(adjVal) || 0; input.value = formatBspFromCents(cents);
          }catch(e){ console.warn('price-timer-product update bsp input', e); }
        });
      }

      function scheduleNextCheck(){ const now = getNowSeconds(); const elapsedSec = now - startTime; const elapsedMin = Math.floor(elapsedSec/60); const currentInterval = Math.floor(elapsedMin / checkIntervalMinutes); const nextChangeTs = startTime + ((currentInterval+1) * checkIntervalMinutes * 60); const msUntilNext = (nextChangeTs - now) * 1000; const scheduleMs = (msUntilNext <= 0 || msUntilNext > checkIntervalMinutes * 60 * 1000 * 2) ? 500 : msUntilNext + 150;

        // Max intervals check disabled - relying on target price check only (FIRST INSTANCE)
        // try {
        //   if (Number.isFinite(productMaxIntervals) && productMaxIntervals > 0) {
        //     const stepsNow = getElapsedSteps();
        //     if (stepsNow >= productMaxIntervals) { stopProductTimerAndShowEnded(); return; }
        //   }
        // } catch (e) { /* ignore */ }

        setTimeout(()=>{ checkAndUpdate(); }, scheduleMs); }

      function checkAndUpdate(){ const steps = getElapsedSteps(); if(lastProcessedSteps === -1){ updatePricesForSteps(steps); lastProcessedSteps = steps; enableAddToCart(); scheduleNextCheck(); return; } if(steps !== lastProcessedSteps){ updatePricesForSteps(steps); lastProcessedSteps = steps; } scheduleNextCheck(); }

      try{ normalizeBspInputs(); }catch(e){console.warn('normalizeBspInputs failed product', e);} checkAndUpdate(); var mainIntervalId = setInterval(()=>{ const s = getElapsedSteps(); if(s !== lastProcessedSteps) checkAndUpdate(); }, Math.max(30, Math.floor(checkIntervalMinutes * 60 / 3)) * 1000); var safetyIntervalId = setInterval(() => { if (timerEnded) { if (safetyIntervalId) { clearInterval(safetyIntervalId); safetyIntervalId = null; } return; } try {  const steps = getElapsedSteps(); if (shouldStopTimer(steps)) { console.log("Safety interval stopping timer"); stopProductTimerAndShowEnded(); if (mainIntervalId) { clearInterval(mainIntervalId); mainIntervalId = null; } if (safetyIntervalId) { clearInterval(safetyIntervalId); safetyIntervalId = null; } return; } } catch (e) { console.error("Safety interval error:", e); } }, Math.max(30, Math.floor(checkIntervalMinutes * 60 / 3)) * 1000);

      // Live clock + notification UI (updates timer-debug if present)
      (function(){
        var lastShownSteps = -1;
        function pad(n){ return String(n).padStart(2,'0'); }

        function updateClockUI(){
          try{
            var now = Date.now();
            var elapsedMs = (now/1000 | 0) - startTime; // seconds approx
            if(elapsedMs < 0) elapsedMs = 0;
            var elapsedSeconds = Math.floor(elapsedMs);
            var elapsedMinutes = Math.floor(elapsedSeconds / 60);
            var steps = Math.floor(elapsedMinutes / checkIntervalMinutes);

            // Don't check stop conditions in clock UI - only check when actually updating prices
            // Update debug panel
            var dbg = document.getElementById('timer-debug');
            if(dbg) dbg.style.display = 'block';
            var clockEl = document.getElementById('timer-live-clock'); if(clockEl){
              var hours = Math.floor(elapsedSeconds / 3600);
              var minutes = Math.floor((elapsedSeconds % 3600) / 60);
              var seconds = elapsedSeconds % 60;
              clockEl.textContent = [hours, minutes, seconds].map(function(num){ return pad(num); }).join(':');
            }
            var es = document.getElementById('elapsed-seconds'); if(es) es.textContent = elapsedSeconds;
            var em = document.getElementById('elapsed-minutes'); if(em) em.textContent = elapsedMinutes;
            var esteps = document.getElementById('elapsed-steps'); if(esteps) esteps.textContent = steps;
            var cur = document.getElementById('current-steps'); if(cur) cur.textContent = steps;

            // Calculate time until next step
            var currentIntervalSeconds = elapsedMinutes * 60 + (elapsedSeconds % 60);
            var intervalSeconds = checkIntervalMinutes * 60;
            var secondsUntilNext = intervalSeconds - (currentIntervalSeconds % intervalSeconds);
            if(secondsUntilNext < 0) secondsUntilNext = 0;
            var nextEl = document.getElementById('next-step-time'); if(nextEl){
              var nm = Math.floor(secondsUntilNext/60); var ns = Math.floor(secondsUntilNext%60);
              nextEl.textContent = pad(nm) + ':' + pad(ns);
            }

            // Update product banner countdown/progress if present
            try {
              var productBanner = document.getElementById('product-price-timer');
              if (productBanner) {
                // if banner already marked ended, ensure it stays ended and skip updates
                if (productBanner.getAttribute && productBanner.getAttribute('data-timer-ended') === 'true') {
                  var pProgress = productBanner.querySelector('#price-timer-progress'); if (pProgress) pProgress.style.width = '100%';
                  var pCountdown = productBanner.querySelector('#timer-countdown'); if (pCountdown) pCountdown.textContent = '--:--:--';
                  var pEnded = productBanner.querySelector('#timer-ended-message'); if (pEnded) pEnded.style.display = 'block';
                } else {
                  var nextStepTs = startTime + ((steps + 1) * checkIntervalMinutes * 60);
                  var diffMs = (nextStepTs * 1000) - now;
                  var productCountdown = productBanner.querySelector('#timer-countdown') || document.getElementById('timer-countdown');
                  if (productCountdown) productCountdown.textContent = (diffMs <= 0) ? '--:--:--' : [Math.floor(diffMs/3600000).toString().padStart(2,'0'), Math.floor((diffMs%3600000)/60000).toString().padStart(2,'0'), Math.floor((diffMs%60000)/1000).toString().padStart(2,'0')].join(':');
                  var productProgress = productBanner.querySelector('#price-timer-progress') || document.getElementById('price-timer-progress');
                  if (productProgress && checkIntervalMinutes > 0) {
                    var percent = Math.max(0, Math.min(100, (1 - (diffMs / (checkIntervalMinutes * 60 * 1000))) * 100));
                    productProgress.style.width = percent + '%';
                  }
                  var productChange = productBanner.querySelector('#timer-upcoming-change') || document.getElementById('timer-upcoming-change');
                  const currencySymbol = (typeof window.Shopify !== 'undefined' && window.Shopify.currency && window.Shopify.currency.active) ? window.shop.currency.symbol : 'kr';
                  if (productChange) productChange.textContent = (isDecrease ? '-' : '+') + stepMajor + ' ' + currencySymbol;
                }
              }
            } catch(e) { /* ignore */ }

            // Trigger a brief notification when steps increase (only once)
            if(steps > lastShownSteps){
              // no visual notification required - simply update lastShownSteps and allow other updates to run
              lastShownSteps = steps;
            }

          }catch(e){ console.warn('price-timer-product: updateClockUI error', e); }
        }

        // update every second for UI
        updateClockUI();
        setInterval(updateClockUI, 1000);
      })();

    } catch(err){ console.error('price-timer-product init error', err); }
  });
})();

// Guard: skip client-side timer updates if server applied adjustments
if (document.querySelector('input[name="properties[_timer_adjusted]"]') || document.querySelector('[data-timer-server-applied]')) {
  console.debug('price-timer-product: server-applied timer detected — skipping client updates');
} else {
  (function(){
    document.addEventListener('DOMContentLoaded', function(){
      try {
        // Read config either from a JSON script or from #timer-config data attributes
        var cfg = null;
        var cfgScript = document.querySelector('script[data-timer-config]');
        if(cfgScript){
          try{ cfg = JSON.parse(cfgScript.textContent || cfgScript.innerText || '{}'); }catch(e){ cfg = null; }
        }
        var cfgDiv = document.getElementById('timer-config');
        if(!cfg){
          if(cfgDiv){
            cfg = {
              enabled: cfgDiv.dataset.enabled === 'true' || cfgDiv.dataset.enabled === true,
              startTime: Number(cfgDiv.dataset.startTime) || 0,
              stepMajor: Number(cfgDiv.dataset.stepMajor) || Number(cfgDiv.dataset.stepMajor) || 0,
              isDecrease: (cfgDiv.dataset.isDecrease === 'true' || cfgDiv.dataset.isDecrease === true),
              checkIntervalMinutes: Number(cfgDiv.dataset.checkIntervalMinutes) || Number(cfgDiv.dataset.checkIntervalMinutes) || 1
            };
          }
        }
        if(!cfg || !cfg.enabled) return console.info('Price timer (product): no config');

        const startTime = Number(cfg.startTime) || 0;
        const stepMajor = Number(cfg.stepMajor) || 0;
        const isDecrease = Boolean(cfg.isDecrease);
        const checkIntervalMinutes = Number(cfg.checkIntervalMinutes) || 1;

        // New: read product-level max intervals so we can stop product banner when reached
        const productMaxNode = document.getElementById('product-max-intervals');
        const productMaxIntervals = (function(){
          // Try to get max intervals from template first
          if (productMaxNode) {
            var v = productMaxNode.dataset && productMaxNode.dataset.maxIntervals ? productMaxNode.dataset.maxIntervals : productMaxNode.getAttribute('data-max-intervals');
            var templateMax = parseInt(v,10);
            if (!isNaN(templateMax) && templateMax > 0) {
              console.log('Using template max intervals (2nd):', templateMax);
              return templateMax;
            }
          }
          
          // Calculate max intervals based on actual HTML prices
          try {
            const priceEl = document.querySelector('[data-timer-adjustable-price]');
            if (!priceEl) {
              console.log('No price element found for max intervals calculation (2nd)');
              return NaN;
            }
            
            const currentPrice = parseCentsFromDisplay(priceEl.textContent);
            const targetAttr = priceEl.getAttribute('data-original-price');
            const targetPrice = targetAttr ? (/^\d+$/.test(targetAttr.trim()) ? parseInt(targetAttr.trim(), 10) : parseCentsFromDisplay(targetAttr)) : null;
            
            if (currentPrice != null && targetPrice != null) {
              const priceDiff = Math.abs(targetPrice - currentPrice);
              const stepCents = centsFromMajor(stepMajor);
              const calculatedMax = Math.floor(priceDiff / stepCents);
              
              console.log('Calculated max intervals from actual prices (2nd):', {
                currentPrice: currentPrice,
                targetPrice: targetPrice,
                priceDiff: priceDiff,
                stepCents: stepCents,
                calculatedMax: calculatedMax
              });
              
              return calculatedMax > 0 ? calculatedMax : NaN;
            }
          } catch (e) {
            console.error('Error calculating max intervals (2nd):', e);
          }
          
          console.log('Could not determine max intervals (2nd)');
          return NaN;
        })();

        function hasReachedTargetPrice() {
          try {
            // Get the current displayed price
            const priceEl = document.querySelector('[data-timer-adjustable-price]');
            if (!priceEl) return false;
            
            const currentPrice = parseCentsFromDisplay(priceEl.textContent);
            if (currentPrice == null) return false;
            
            // Get the target price from data attribute
            const targetAttr = priceEl.getAttribute('data-original-price');
            if (!targetAttr) return false;
            
            const targetPrice = /^\d+$/.test(targetAttr.trim()) ? 
              parseInt(targetAttr.trim(), 10) : 
              parseCentsFromDisplay(targetAttr);
            
            if (targetPrice == null) return false;
            
            // Check if we've reached or exceeded the target
            if (isDecrease) {
              return currentPrice <= targetPrice;
            } else {
              return currentPrice >= targetPrice;
            }
          } catch (e) {
            return false;
          }
        }

        function shouldStopTimer(steps) {
          // DISABLED: Max intervals check - using target price check only (2nd instance)
          const maxIntervalsReached = false; // Disabled: template calculation is unreliable
          
          const targetPriceReached = hasReachedTargetPrice();
          
          console.log('shouldStopTimer debug (2nd):', {
            steps: steps,
            maxIntervalsReached: maxIntervalsReached,
            targetPriceReached: targetPriceReached,
            willStop: maxIntervalsReached || targetPriceReached
          });
          
          return maxIntervalsReached || targetPriceReached;
        }

        function stopProductTimerAndShowEnded() {
          try {
            timerEnded = true;
            
            const banner = document.getElementById('product-price-timer');
            const progress = document.getElementById('price-timer-progress');
            const countdown = document.getElementById('timer-countdown');
            const endedMsg = document.getElementById('timer-ended-message');
            const changeEl = document.getElementById('timer-upcoming-change');
            if (progress) try { progress.style.width = '100%'; } catch(e){}
            if (countdown) try { countdown.textContent = '--:--:--'; } catch(e){}
            if (banner) try { banner.style.backgroundColor = '#E11D48'; banner.classList.add('price-timer-ended'); banner.setAttribute('data-timer-ended', 'true'); } catch(e){}
            if (endedMsg) try { endedMsg.style.display = 'block'; endedMsg.textContent = 'Bedre held næste gang.'; } catch(e){}
            const currencySymbol = (typeof window.Shopify !== 'undefined' && window.Shopify.currency && window.Shopify.currency.active) ? window.shop.currency.symbol : 'kr';
            if (changeEl) try { changeEl.textContent = (isDecrease ? '-' : '+') + '0 ' + currencySymbol; } catch(e){}

            // mark ended globally and stop background checks
            try { window.__priceTimerEnded = true; } catch(e){}
            try { if (typeof mainIntervalId !== 'undefined' && mainIntervalId) { clearInterval(mainIntervalId); mainIntervalId = null; } } catch(e){}
            try { if (typeof safetyIntervalId !== 'undefined' && safetyIntervalId) { clearInterval(safetyIntervalId); safetyIntervalId = null; } } catch(e){}
            try { if (typeof __priceTimerNextTimeout !== 'undefined' && __priceTimerNextTimeout) { clearTimeout(__priceTimerNextTimeout); __priceTimerNextTimeout = null; } } catch(e){}
          } catch (e) { /* ignore */ }
        }

        // Disable #addToCartButton until initial price synchronization has completed
        function disableAddToCart(){
          try{
            var btn = document.querySelector('#addToCartButton');
            if(btn){
              btn.setAttribute('disabled','disabled');
              btn.dataset._origCursor = btn.style.cursor || '';
              btn.style.cursor = 'not-allowed';
              btn.setAttribute('aria-disabled','true');
            }
          }catch(e){/* silent */}
        }
        function enableAddToCart(){
          try{
            var btn = document.querySelector('#addToCartButton');
            if(btn){
              btn.removeAttribute('disabled');
              btn.style.cursor = btn.dataset._origCursor || '';
              try{ delete btn.dataset._origCursor; }catch(e){}
              btn.removeAttribute('aria-disabled');
            }
          }catch(e){/* silent */}
        }

        // prevent adding to cart until we've done the initial price update
        disableAddToCart();

        // internal state
        let timerEnded = false;

        function centsFromMajor(m){ return Math.round(m * 100); }
        function getCurrencySymbol() {
          // Try to get currency symbol from Shopify's currency object
          if (typeof window.Shopify !== 'undefined' && window.Shopify.currency && window.Shopify.currency.active) {
            const currencyCode = window.Shopify.currency.active;
            // Map common currency codes to symbols
            const currencySymbols = {
              'USD': '$', 'EUR': '€', 'GBP': '£', 'DKK': 'kr', 'SEK': 'kr', 'NOK': 'kr',
              'JPY': '¥', 'CAD': '$', 'AUD': '$', 'CHF': 'CHF', 'PLN': 'zł', 'CZK': 'Kč'
            };
            return currencySymbols[currencyCode] || currencyCode;
          }
          return 'kr'; // fallback
        }
        function formatPriceFromCents(cents){ 
          const major = (cents/100).toFixed(2); 
          const currencySymbol = getCurrencySymbol();
          // Always format as "300,00 kr" (amount + space + symbol)
          var _p = major.split('.'); return _p[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + _p[1] + ' ' + currencySymbol;
        }
        function formatBspFromCents(cents){ var c = Number(cents); if(isNaN(c)) return ''; var major = Math.floor(c/100); var centsPart = Math.abs(c%100); var centsStr = centsPart<10 ? '0'+centsPart : String(centsPart); return '['+major+'.'+centsStr+']'; }
        function parseCentsFromDisplay(display){ 
          if(!display) return null; 
          const currencySymbol = getCurrencySymbol();
          var cleaned = String(display).replace(new RegExp(currencySymbol, 'g'),'').trim(); 
          cleaned = cleaned.replace(/[^0-9.,]/g,''); 
          if(cleaned.indexOf('.')!==-1 && cleaned.indexOf(',')!==-1){ 
            cleaned = cleaned.replace(/\./g,'').replace(/,/,'.'); 
          } else { 
            cleaned = cleaned.replace(/,/,'.'); 
          } 
          var num = parseFloat(cleaned); 
          if(isNaN(num)) return null; 
          return Math.round(num*100); 
        }

        function updateFormBspInForm(form, newCents){ if(!form) return; form.querySelectorAll('input[name="properties[_bsp]"]').forEach(input => { input.value = formatBspFromCents(newCents); }); }

        // Debug
        try { console.info('price-timer-product init', {startTime: startTime, stepMajor: stepMajor, isDecrease: isDecrease, checkIntervalMinutes: checkIntervalMinutes}); } catch(e){}

        function normalizeBspInputs(){
          var inputs = document.querySelectorAll('input[name="properties[_bsp]"]');
          inputs.forEach(function(input){
            try{
              var v = (input.value||'').trim();
              if(!v) return;
              if(v[0] === '[' && v[v.length-1] === ']'){
                var inner = v.slice(1,-1).trim();
                if(inner === '') return;
                var parts = inner.split(',').map(function(p){ return p.trim(); }).filter(Boolean);
                var out = parts.map(function(item){
                  if(/^\d+$/.test(item)){
                    var cents = parseInt(item,10);
                    var major = Math.floor(cents/100);
                    var centsPart = Math.abs(cents%100);
                    var centsStr = centsPart < 10 ? ('0'+centsPart) : String(centsPart);
                    return major + '.' + centsStr;
                  }
                  if(/^\d+\.\d{2}$/.test(item)) return item;
                  var p = parseCentsFromDisplay(item);
                  if(p != null){
                    var maj = Math.floor(p/100);
                    var cp = Math.abs(p%100);
                    var cs = cp < 10 ? ('0'+cp) : String(cp);
                    return maj + '.' + cs;
                  }
                  return item;
                });
                input.value = '[' + out.join(',') + ']';
              }
            }catch(e){
              console.warn('normalizeBspInputs product', e);
            }
          });
        }

        // core
        var lastProcessedSteps = -1;
        function getNowSeconds(){ return Math.floor(Date.now()/1000); }
        function getElapsedSteps(){ const now = getNowSeconds(); if(now<=startTime) return 0; const elapsedSec = now - startTime; const elapsedMin = Math.floor(elapsedSec/60); if(checkIntervalMinutes<=0) return 0; return Math.floor(elapsedMin / checkIntervalMinutes); }

        function updatePricesForSteps(steps){
          console.debug('price-timer-product.updatePricesForSteps', {steps: steps, lastProcessedSteps: lastProcessedSteps});
          const sign = isDecrease ? -1 : 1;
          const stepDelta = centsFromMajor(stepMajor) * sign;
          var foundAny = false;
          document.querySelectorAll('#product-section [data-timer-adjustable-price]').forEach(el => {
            foundAny = true;
            try{
              const appliedAttr = el.getAttribute('data-applied-steps');
              const applied = (appliedAttr!=null && appliedAttr!=='')?parseInt(appliedAttr,10):null;
              const displayedCents = parseCentsFromDisplay(el.getAttribute('data-timer-adjustable-price') || el.textContent);
              if(displayedCents==null) {
                console.warn('price-timer-product: cannot parse displayed price for element', el);
                return;
              }
              const capAttr = el.getAttribute('data-original-price');
              const capCents = (capAttr && String(capAttr).trim()!=='') ? (/^\d+$/.test(String(capAttr).trim())?parseInt(String(capAttr).trim(),10):parseCentsFromDisplay(capAttr)) : null;

              if(applied==null){ el.setAttribute('data-applied-steps', String(steps)); el.setAttribute('data-timer-adjustable-price', formatPriceFromCents(displayedCents)); return; }
              const diff = steps - applied; if(diff===0) return;
              let newCents = displayedCents + (stepDelta * diff);
              if(capCents!=null){ if(!isDecrease){ if(newCents>capCents) newCents = capCents; } else { if(newCents<capCents) newCents = capCents; } }
              el.setAttribute('data-timer-adjustable-price', formatPriceFromCents(newCents)); el.innerText = formatPriceFromCents(newCents); el.setAttribute('data-applied-steps', String(steps));
              console.debug('price-timer-product: updated element', {productId: el.getAttribute('data-product-id'), newCents: newCents});
              const productId = el.getAttribute('data-product-id');
              if(productId){ const form = document.querySelector('#add_to_cart_container form[action*="/cart/add"]'); if(form) updateFormBspInForm(form, newCents); }
              else { const form = el.closest('form'); if(form) updateFormBspInForm(form, newCents); }

            }catch(e){ console.error('price-timer-product update', e); }
          });
          if(!foundAny) console.info('price-timer-product: no adjustable price elements found on page');

          // update inputs
          document.querySelectorAll('input[name="properties[_bsp]"]').forEach(input => {
            try{
              const card = input.closest('.product_card, .product-card, .product'); if(!card) return; const adj = card.querySelector('[data-timer-adjustable-price]'); if(!adj) return; const adjVal = adj.getAttribute('data-timer-adjustable-price'); if(!adjVal) return; const cents = parseCentsFromDisplay(adjVal) || 0; input.value = formatBspFromCents(cents);
            }catch(e){ console.warn('price-timer-product update bsp input', e); }
          });
        }

        function scheduleNextCheck(){ const now = getNowSeconds(); const elapsedSec = now - startTime; const elapsedMin = Math.floor(elapsedSec/60); const currentInterval = Math.floor(elapsedMin / checkIntervalMinutes); const nextChangeTs = startTime + ((currentInterval+1) * checkIntervalMinutes * 60); const msUntilNext = (nextChangeTs - now) * 1000; const scheduleMs = (msUntilNext <= 0 || msUntilNext > checkIntervalMinutes * 60 * 1000 * 2) ? 500 : msUntilNext + 150;

        // DISABLED: Max intervals check - using target price check only
        // try {
        //   if (Number.isFinite(productMaxIntervals) && productMaxIntervals > 0) {
        //     const stepsNow = getElapsedSteps();
        //     if (stepsNow >= productMaxIntervals) { stopProductTimerAndShowEnded(); return; }
        //   }
        // } catch (e) { /* ignore */ }

        setTimeout(()=>{ checkAndUpdate(); }, scheduleMs); }

      function checkAndUpdate(){ const steps = getElapsedSteps(); if(lastProcessedSteps === -1){ updatePricesForSteps(steps); lastProcessedSteps = steps; enableAddToCart(); scheduleNextCheck(); return; } if(steps !== lastProcessedSteps){ updatePricesForSteps(steps); lastProcessedSteps = steps; } scheduleNextCheck(); }

      try{ normalizeBspInputs(); }catch(e){console.warn('normalizeBspInputs failed product', e);} checkAndUpdate(); var mainIntervalId = setInterval(()=>{ const s = getElapsedSteps(); if(s !== lastProcessedSteps) checkAndUpdate(); }, Math.max(30, Math.floor(checkIntervalMinutes * 60 / 3)) * 1000); var safetyIntervalId = setInterval(() => { if (timerEnded) { if (safetyIntervalId) { clearInterval(safetyIntervalId); safetyIntervalId = null; } return; } try {  const steps = getElapsedSteps(); if (shouldStopTimer(steps)) { console.log("Safety interval stopping timer"); stopProductTimerAndShowEnded(); if (mainIntervalId) { clearInterval(mainIntervalId); mainIntervalId = null; } if (safetyIntervalId) { clearInterval(safetyIntervalId); safetyIntervalId = null; } return; } } catch (e) { console.error("Safety interval error:", e); } }, Math.max(30, Math.floor(checkIntervalMinutes * 60 / 3)) * 1000);

      // Live clock + notification UI (updates timer-debug if present)
      (function(){
        var lastShownSteps = -1;
        function pad(n){ return String(n).padStart(2,'0'); }

        function updateClockUI(){
          try{
            var now = Date.now();
            var elapsedMs = (now/1000 | 0) - startTime; // seconds approx
            if(elapsedMs < 0) elapsedMs = 0;
            var elapsedSeconds = Math.floor(elapsedMs);
            var elapsedMinutes = Math.floor(elapsedSeconds / 60);
            var steps = Math.floor(elapsedMinutes / checkIntervalMinutes);

            // Don't check stop conditions in clock UI - only check when actually updating prices
            
            // Update debug panel
            var dbg = document.getElementById('timer-debug');
            if(dbg) dbg.style.display = 'block';
            var clockEl = document.getElementById('timer-live-clock'); if(clockEl){
              var hours = Math.floor(elapsedSeconds / 3600);
              var minutes = Math.floor((elapsedSeconds % 3600) / 60);
              var seconds = elapsedSeconds % 60;
              clockEl.textContent = [hours, minutes, seconds].map(function(num){ return pad(num); }).join(':');
            }
            var es = document.getElementById('elapsed-seconds'); if(es) es.textContent = elapsedSeconds;
            var em = document.getElementById('elapsed-minutes'); if(em) em.textContent = elapsedMinutes;
            var esteps = document.getElementById('elapsed-steps'); if(esteps) esteps.textContent = steps;
            var cur = document.getElementById('current-steps'); if(cur) cur.textContent = steps;

            // Calculate time until next step
            var currentIntervalSeconds = elapsedMinutes * 60 + (elapsedSeconds % 60);
            var intervalSeconds = checkIntervalMinutes * 60;
            var secondsUntilNext = intervalSeconds - (currentIntervalSeconds % intervalSeconds);
            if(secondsUntilNext < 0) secondsUntilNext = 0;
            var nextEl = document.getElementById('next-step-time'); if(nextEl){
              var nm = Math.floor(secondsUntilNext/60); var ns = Math.floor(secondsUntilNext%60);
              nextEl.textContent = pad(nm) + ':' + pad(ns);
            }

            // Update product banner countdown/progress if present
            try {
              var productBanner = document.getElementById('product-price-timer');
              if (productBanner) {
                // if banner already marked ended, ensure it stays ended and skip updates
                if (productBanner.getAttribute && productBanner.getAttribute('data-timer-ended') === 'true') {
                  var pProgress = productBanner.querySelector('#price-timer-progress'); if (pProgress) pProgress.style.width = '100%';
                  var pCountdown = productBanner.querySelector('#timer-countdown'); if (pCountdown) pCountdown.textContent = '--:--:--';
                  var pEnded = productBanner.querySelector('#timer-ended-message'); if (pEnded) pEnded.style.display = 'block';
                } else {
                  var nextStepTs = startTime + ((steps + 1) * checkIntervalMinutes * 60);
                  var diffMs = (nextStepTs * 1000) - now;
                  var productCountdown = productBanner.querySelector('#timer-countdown') || document.getElementById('timer-countdown');
                  if (productCountdown) productCountdown.textContent = (diffMs <= 0) ? '--:--:--' : [Math.floor(diffMs/3600000).toString().padStart(2,'0'), Math.floor((diffMs%3600000)/60000).toString().padStart(2,'0'), Math.floor((diffMs%60000)/1000).toString().padStart(2,'0')].join(':');
                  var productProgress = productBanner.querySelector('#price-timer-progress') || document.getElementById('price-timer-progress');
                  if (productProgress && checkIntervalMinutes > 0) {
                    var percent = Math.max(0, Math.min(100, (1 - (diffMs / (checkIntervalMinutes * 60 * 1000))) * 100));
                    productProgress.style.width = percent + '%';
                  }
                  var productChange = productBanner.querySelector('#timer-upcoming-change') || document.getElementById('timer-upcoming-change');
                  const currencySymbol = (typeof window.Shopify !== 'undefined' && window.Shopify.currency && window.Shopify.currency.active) ? window.shop.currency.symbol : 'kr';
                  if (productChange) productChange.textContent = (isDecrease ? '-' : '+') + stepMajor + ' ' + currencySymbol;
                }
              }
            } catch(e) { /* ignore */ }

            // Trigger a brief notification when steps increase (only once)
            if(steps > lastShownSteps){
              // no visual notification required - simply update lastShownSteps and allow other updates to run
              lastShownSteps = steps;
            }

          }catch(e){ console.warn('price-timer-product: updateClockUI error', e); }
        }

        // update every second for UI
        updateClockUI();
        setInterval(updateClockUI, 1000);
      })();

      } catch(err){ console.error('price-timer-product init error', err); }
    });
  })();
}